import { render, staticRenderFns } from "./two-floor.vue?vue&type=template&id=db254490&scoped=true&"
import script from "./two-floor.vue?vue&type=script&lang=js&"
export * from "./two-floor.vue?vue&type=script&lang=js&"
import style0 from "./two-floor.vue?vue&type=style&index=0&id=db254490&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db254490",
  null
  
)

export default component.exports